import React, {useEffect, useRef, useState} from 'react';
import {Checkbox} from "@chakra-ui/react";

export type Subject = {
  courseName: string,
  index: number,
  courses: string[],
  checkedState: boolean[],
  setCheckedState: React.Dispatch<React.SetStateAction<boolean[]>>
}

function Courses({courseName, index, courses, checkedState, setCheckedState}: Subject) {
   const handleOnChange = (position: number) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );

    setCheckedState(updatedCheckedState);
  }

  return (
    <Checkbox id={`${index}`} name={courseName} value={courseName}
              bgColor={`${checkedState[index] ? "orange.200" : "gray.200"}`}
              p={2.5} m={2}
              borderRadius={"10px"} fontSize={"14px"} fontWeight={"medium"} color={"#111827"}
              textTransform={"capitalize"}
              checked={checkedState[index]}
              onChange={() => handleOnChange(index)} defaultChecked={false}>{courseName}</Checkbox>
  );
}

export default Courses;